import { render, staticRenderFns } from "./Exhibitor.vue?vue&type=template&id=38d697df&scoped=true"
import script from "./Exhibitor.vue?vue&type=script&lang=js"
export * from "./Exhibitor.vue?vue&type=script&lang=js"
import style0 from "./Exhibitor.vue?vue&type=style&index=0&id=38d697df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d697df",
  null
  
)

export default component.exports